<div class="login-wrapper loginSpinnerDiv">
    <div class="login-left"></div>
    <div class="login-right">
        <div class="login-container">
            <div class="login-box">
                <div class="login-logo text-center">
                    <img src="../../../assets/images/logo.png">
                </div>
                <h2 class="text-center">Secure Login to iFast</h2>

                <p-messages [showTransitionOptions]="'300ms'" [hideTransitionOptions]="'200ms'" [(value)]="msgs"></p-messages>
                
                <div class="message message-error" [hidden]="!showToggle">
                    <div class="message-wrapper">
                        <span class="message-icon pi pi-times-circle"></span>
                        <p>{{ errorMessage }}</p>
                        <button class="p-message-close" type="button" (click)="closeErrorDiv()">
                            <i class="p-message-close-icon pi pi-times"></i>
                        </button>
                    </div>
                </div>

                <div class="loginSpinner">
                    <p-progressSpinner [style]="{width: '50px', height: '50px'}" strokeWidth="5" [hidden]="!showSpinner"></p-progressSpinner>
                </div>
                <button pButton label="Login with Auth0" class="btn-block mt-2" (click)="loginWithAuth0()" [disabled]="showSpinner"></button>
            </div>
        </div>
    </div>
</div>